import {Component, Input, OnInit} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Request} from '../../../classes/request';
import {RequestAccess} from '../../../classes/requestAccess';
import {RequestAccessService} from '../../../services/requestAccess';

@Component({
    selector: 'app-request-access-modal',
    templateUrl: './request-access-modal.component.html',
    styleUrls: ['./request-access-modal.component.css']
})
export class RequestAccessModalComponent implements OnInit {
    @Input() public request: Request = new Request();

    accesses: Array<RequestAccess> = [];
    loading = true;
    loadFailed = false;

    constructor(public activeModal: NgbActiveModal,
                private requestAccessService: RequestAccessService) { }

    ngOnInit(): void {
        if (!this.request.IDRequest) {
            this.loading = false;
            return;
        }
        this.requestAccessService.getAllByIDRequest(this.request.IDRequest)
            .subscribe({
                next: (accesses: Array<RequestAccess>) => {
                    this.accesses = accesses;
                    this.loading = false;
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                    this.loadFailed = true;
                    this.loading = false;
                }
            });
    }

    getAccessorType(access: RequestAccess): string {
        return access.IsAuthenticated ? 'Utente' : 'Cliente';
    }

    getAccessorName(access: RequestAccess): string {
        if (access.IsAuthenticated) {
            return access.user?.Username || 'Utente eliminato';
        }
        const customer = access.customer;
        if (!customer) {
            return 'Cliente non ancora registrato';
        }
        const fullName = [customer.Name, customer.Surname].filter(part => !!part).join(' ');
        return customer.CompanyName || fullName || 'Cliente non ancora registrato';
    }
}
